import _slicedToArray from "/workspace/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { useEffect, useState } from 'react';

function getItem(key) {
  if (typeof window === 'undefined') {
    return null;
  }

  var item = window.localStorage.getItem(key);

  if (item !== null) {
    try {
      return JSON.parse(item);
    } catch (_a) {// ignore error
    }
  }
}

function setItem(key, value) {
  if (value === undefined) {
    window.localStorage.removeItem(key);
  } else {
    var toStore = JSON.stringify(value);
    window.localStorage.setItem(key, toStore);
    return JSON.parse(toStore);
  }
}

export function useLocalStorage(key) {
  var _useState = useState(function () {
    return getItem(key);
  }),
      _useState2 = _slicedToArray(_useState, 2),
      value = _useState2[0],
      setValue = _useState2[1];

  useEffect(function () {
    setValue(getItem(key));
  }, [key]);
  useEffect(function () {
    setItem(key, value);
  }, [value, key]);
  return [value, setValue];
}